import { ICrmActionConfig } from '@care-portals/api-interfaces';
import { pipelinesExcept } from './workflows';

export const CrmActions: ICrmActionConfig = {
  activity: {
    functions: {
      createActivity: {
        label: 'Create Activity',
        params: [
          { label: 'Type', key: 'type', type: 'string' },
          { label: 'Customer ID', key: 'customer', type: 'string' }
        ],
        paramsOptional: [
          { label: 'Label', key: 'label', type: 'string' },
          { label: 'Resource ID', key: 'resourceId', type: 'string' },
          { label: 'Resource Type', key: 'resourceType', type: 'string' },
          { label: 'Note', key: 'note', type: 'textarea' },
          { label: 'Subject', key: 'subject', type: 'string' },
          { label: 'Url', key: 'url', type: 'string' }
        ]
      }
    }
  },
  appointments: {
    functions: {
      createAppointment: {
        label: 'Create Appointment',
        params: [
          {
            key: 'duration',
            label: 'duration',
            type: 'string'
          },
          {
            key: 'reservation',
            label: 'reservation',
            type: 'string'
          },
          {
            key: 'status',
            label: 'status',
            type: 'string'
          },
          {
            key: 'schedule',
            label: 'schedule',
            type: 'string'
          },
          {
            key: 'lead',
            label: 'lead',
            type: 'string'
          },
          {
            key: 'service',
            label: 'service',
            type: 'string'
          }
        ],
        extras: true
      },
      updateAppointment: {
        label: 'Update Appointment',
        params: [
          {
            key: 'id',
            label: 'ID',
            type: 'string'
          }
        ],
        paramsOptional: [
          {
            key: 'duration',
            label: 'duration',
            type: 'number'
          },
          // {
          //   key: 'reservation',
          //   label: 'reservation',
          //   type: 'string'
          // },
          {
            key: 'status',
            label: 'status',
            type: 'string'
          },
          {
            key: 'schedule',
            label: 'schedule',
            type: 'string'
          },
          {
            key: 'lead',
            label: 'lead',
            type: 'string'
          },
          {
            key: 'service',
            label: 'service',
            type: 'string'
          },
          { label: 'Payment Type', key: 'paymentType', type: 'string' },
          { label: 'Payment Amount', key: 'paymentAmount', type: 'string' },
          { label: 'Payment Status', key: 'paymentStatus', type: 'string' },
          { label: 'Payment Message', key: 'paymentMessage', type: 'string' },
          { label: 'Payment ID', key: 'paymentId', type: 'string' }
        ],

        extras: true
      },
      findAppointment: {
        label: 'Find One',
        params: [{ label: 'Json Filter', key: 'filter', type: 'string' }]
      },
      capturePayment: {
        label: 'Capture Payment',
        version: 2,
        params: [
          {
            key: 'id',
            label: 'Appointment ID',
            type: 'string'
          }
        ]
      }
    }
  },
  Leads: {
    functions: {
      createLeadFromForm: {
        label: 'Create/Update Lead',
        pipelines: ['form'],
        params: [],
        paramsOptional: [
          { key: 'emailFieldName', label: 'Email Field', type: 'string' },
          { key: 'firstNameFieldName', type: 'string' },
          { key: 'lastNameFieldName', type: 'string' },
          { key: 'phoneFieldName', type: 'string' },
          { key: 'dobFieldName', type: 'string' },
          { key: 'notesFieldName', type: 'string' },
          { key: 'genderFieldName', type: 'string' },
          { key: 'hcNumberFieldName', type: 'string' },
          { key: 'hcVerFieldName', type: 'string' },
          { key: 'hcEffFieldName', type: 'string' },
          { key: 'hcExpFieldName', type: 'string' },
          { key: 'address1FieldName', type: 'string' },
          { key: 'address2FieldName', type: 'string' },
          { key: 'cityFieldName', type: 'string' },
          { key: 'postalFieldName', type: 'string' },
          { key: 'provinceFieldName', type: 'string' },
          { key: 'countryFieldName', type: 'string' }
        ],
        extras: true
      },
      upsertLead: {
        label: 'Create/Update Lead',
        version: 2,
        pipelines: ['webhook', 'task'],
        params: [{ key: 'email', label: 'Email Field', type: 'string' }],
        paramsOptional: [
          { key: 'firstName', type: 'string' },
          { key: 'lastName', type: 'string' },
          { key: 'phone', type: 'string' },
          { key: 'dob', type: 'string' },
          { key: 'notes', type: 'string' },
          { key: 'gender', type: 'string' },
          { key: 'hc.number', type: 'string' },
          { key: 'hc.version', type: 'string' },
          { key: 'hc.effectiveDate', type: 'string' },
          { key: 'hc.expiryDate', type: 'string' },
          { key: 'address.address_1', type: 'string' },
          { key: 'address.address_2', type: 'string' },
          { key: 'address.city', type: 'string' },
          { key: 'address.province', type: 'string' },
          { key: 'address.postal', type: 'string' },
          { key: 'address.country', type: 'string' }
        ],
        extras: true
      },
      updateLead: {
        label: 'Update Lead By Email',
        params: [{ label: 'Email', key: 'email', type: 'string' }],
        paramsOptional: [
          { label: 'First Name', key: 'firstName', type: 'string' },
          { label: 'Last Name', key: 'lastName', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          { label: 'DOB', key: 'dob', type: 'string' },
          { label: 'Notes', key: 'notes', type: 'string' },
          { label: 'Gender', key: 'gender', type: 'string' },
          { label: 'HC #', key: 'hcNumber', type: 'string' },
          { label: 'HC Ver', key: 'hcVer', type: 'string' },
          { label: 'HC Effective', key: 'hcEff', type: 'string' },
          { label: 'HC Expiry', key: 'hcExp', type: 'string' },
          { label: 'Address 1', key: 'address1', type: 'string' },
          { label: 'Address 2', key: 'address2', type: 'string' },
          { label: 'City', key: 'city', type: 'string' },
          { label: 'Postal', key: 'postal', type: 'string' },
          { label: 'Province', key: 'province', type: 'string' },
          { label: 'Country', key: 'country', type: 'string' },
          { label: 'EMR ID', key: 'emrId', type: 'string' },
          { label: 'Status', key: 'status', type: 'string' }
        ],
        extras: true
      },
      updateLeadById: {
        label: 'Update Lead by ID',
        params: [{ label: 'ID', key: 'id', type: 'string' }],
        paramsOptional: [
          { label: 'First Name', key: 'firstName', type: 'string' },
          { label: 'Last Name', key: 'lastName', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          { label: 'DOB', key: 'dob', type: 'string' },
          { label: 'Notes', key: 'notes', type: 'string' },
          { label: 'Gender', key: 'gender', type: 'string' },
          { label: 'HC #', key: 'hcNumber', type: 'string' },
          { label: 'HC Ver', key: 'hcVer', type: 'string' },
          { label: 'HC Effective', key: 'hcEff', type: 'string' },
          { label: 'HC Expiry', key: 'hcExp', type: 'string' },
          { label: 'Address 1', key: 'address1', type: 'string' },
          { label: 'Address 2', key: 'address2', type: 'string' },
          { label: 'City', key: 'city', type: 'string' },
          { label: 'Postal', key: 'postal', type: 'string' },
          { label: 'Province', key: 'province', type: 'string' },
          { label: 'Country', key: 'country', type: 'string' },
          { label: 'EMR ID', key: 'emrId', type: 'string' },
          { label: 'Status', key: 'status', type: 'string' }
        ],
        extras: true
      },
      findLead: {
        label: 'Find One',
        params: [{ label: 'Email Path', key: 'email', type: 'string' }]
      },
      getLeadPaymentMethods: {
        label: 'Get Payment Methods',
        params: [{ label: 'Lead ID', key: 'leadId', type: 'string' }]
      },
      createCustomerFromLead: {
        version: 2,
        label: 'Convert to customer',
        // Creates a customer -> emits customer.created/customer.signup.
        pipelines: pipelinesExcept('customer'),
        params: [{ label: 'Lead Id', key: 'leadId', type: 'string' }],
        paramsOptional: [
          { label: 'Accept Marketing', key: 'acceptMarketing', type: 'string' },
          {
            label: 'Insurance Available',
            key: 'isInsuranceAvailable',
            type: 'string'
          }
        ]
      }
    }
  },
  customers: {
    functions: {
      findCustomer: {
        label: 'Find One',
        params: [
          { label: 'Email', key: 'email', type: 'string' },
          { label: 'ID', key: 'customerId', type: 'string' }
        ]
      },
      createCustomerFromLead: {
        version: 2,
        label: 'Create customer from lead',
        // Creates a customer -> emits customer.created/customer.signup.
        pipelines: pipelinesExcept('customer'),
        params: [{ label: 'Lead Id', key: 'leadId', type: 'string' }],
        paramsOptional: [
          { label: 'Accept Marketing', key: 'acceptMarketing', type: 'string' },
          {
            label: 'Insurance Available',
            key: 'isInsuranceAvailable',
            type: 'string'
          }
        ]
      },
      updateCustomerById: {
        label: 'Update Customer by ID',
        // Emits customer.updated -> exclude the customer pipeline so it cannot
        // re-trigger the workflow that runs it (infinite loop).
        pipelines: pipelinesExcept('customer'),
        params: [{ label: 'ID', key: 'id', type: 'string' }],
        paramsOptional: [
          { label: 'First Name', key: 'firstName', type: 'string' },
          { label: 'Last Name', key: 'lastName', type: 'string' },
          { label: 'Phone', key: 'phone', type: 'string' },
          { label: 'DOB', key: 'dob', type: 'string' },
          { label: 'Gender', key: 'gender', type: 'string' }
        ],
        extras: true
      },
      assignQuestionnairesToCustomer: {
        label: 'Assign Questionnaires',
        version: 2,
        // Emits customer.qnr-assigned (customer pipeline) -> exclude customer.
        pipelines: pipelinesExcept('customer'),
        params: [
          { label: 'Customer ID', key: 'leadId', type: 'string' },
          { label: 'Questionnaires', key: 'questionnaires', type: 'string' }
        ]
      },
      setCustomerProviders: {
        label: 'Set Assigned Providers',
        version: 2,
        params: [
          { label: 'Customer ID', key: 'customerId', type: 'string' },
          { label: 'Provider IDs', key: 'providerIds', type: 'string' }
        ]
      },
      customerAddToGroup: {
        label: 'Add to Group',
        version: 2,
        // Updates the customer -> emits customer.updated -> exclude customer.
        pipelines: pipelinesExcept('customer'),
        params: [
          { label: 'Customer ID', key: 'customerId', type: 'string' },
          { label: 'Group', key: 'group', type: 'string' }
        ]
      },
      addCustomerProviders: {
        label: 'Add Assigned Provider',
        version: 2,
        params: [
          { label: 'Customer ID', key: 'customerId', type: 'string' },
          { label: 'Provider ID', key: 'providerId', type: 'string' }
        ]
      },
      customerHasIDs: {
        version: 1,
        label: 'Has ID files',
        params: [{ label: 'Customer ID', key: 'customerId', type: 'string' }]
      },
      autoVerifyCustomer: {
        version: 2,
        label: 'Auto Verify Customer',
        // Updates the customer -> emits customer.updated -> exclude customer.
        pipelines: pipelinesExcept('customer'),
        params: [
          { label: 'Customer ID *', key: 'customerId', type: 'string' },
          {
            label: 'Gov ID Form Name (default: govId)',
            key: 'govId',
            type: 'string'
          },
          {
            label: 'Selfie Form Name (default: selfie)',
            key: 'selfie',
            type: 'string'
          },
          {
            label: 'Selfie Required (default: true)',
            key: 'isSelfieRequired',
            type: 'string'
          }
        ]
      }
    }
  },
  Schedule: {
    functions: {
      findSchedule: {
        label: 'Find One',
        params: [{ label: 'Json Filter', key: 'filter', type: 'string' }]
      }
    }
  },
  Tasks: {
    functions: {
      createTaskFromForm: {
        label: 'Form -> Create Task',
        pipelines: ['form'],
        params: [
          { key: 'leadId', type: 'string' },
          { key: 'type', type: 'string' },
          { key: 'description', type: 'string' },
          { key: 'notes', type: 'string' },
          { key: 'status', type: 'string' },
          { key: 'tags', type: 'string' },
          { key: 'isAdminOnly', type: 'string', placeholder: 'true | false' }
        ]
      },
      createTask: {
        label: 'Create Task',
        params: [
          { key: 'leadId', type: 'string' },
          { key: 'type', type: 'string' },
          { key: 'description', type: 'string' },
          { key: 'notes', type: 'string' },
          { key: 'status', type: 'string' },
          { key: 'tags', type: 'string' },
          { key: 'isAdminOnly', type: 'string', placeholder: 'true | false' }
        ]
      }
    }
  },
  Message: {
    functions: {
      sendSMS: {
        label: 'Send SMS',
        params: [
          { label: 'Message', key: 'message', type: 'textarea' },
          { label: 'To Phone', key: 'toPhone', type: 'tel' },
          { label: 'From Phone', key: 'fromPhone', type: 'tel' },
          {
            label: 'Skip if messaged within',
            key: 'skipIfContactedWithin',
            type: 'string',
            placeholder: 'e.g. 30m, 24h, 7d'
          }
        ]
      },
      sendEmail: {
        label: 'Send Email',
        params: [
          { label: 'To', key: 'toEmail', type: 'string' },
          {
            label: 'From',
            key: 'fromEmail',
            type: 'string',
            placeholder: 'no-reply@notify.portals.care'
          },
          {
            label: 'Reply To',
            key: 'replyToEmail',
            type: 'string',
            placeholder: 'Optional'
          },
          { label: 'Subject', key: 'subject', type: 'string' },
          {
            label: 'Template',
            key: 'templateId',
            type: 'lookup:email-templates'
          },
          {
            label: 'Skip if emailed within',
            key: 'skipIfContactedWithin',
            type: 'string',
            placeholder: 'e.g. 30m, 24h, 7d'
          }
        ]
      },
      sendCalendarInvite: {
        label: 'Email Calendar Invite',
        params: [
          { label: 'To', key: 'toEmail', type: 'string' },
          { label: 'attendeeName', key: 'attendeeName', type: 'string' },
          {
            label: 'From',
            key: 'fromEmail',
            type: 'string',
            placeholder: 'no-reply@notify.portals.care'
          },
          { label: 'organizerName', key: 'organizerName', type: 'string' },
          { label: 'Subject', key: 'subject', type: 'string' },
          { label: 'description', key: 'description', type: 'string' },
          {
            label: 'Template',
            key: 'templateId',
            type: 'lookup:email-templates'
          },
          { label: 'start', key: 'start', type: 'string' },
          { label: 'duration in minutes', key: 'duration', type: 'string' }
        ],
        paramsOptional: [
          { label: 'replyToEmail', key: 'replyToEmail', type: 'string' },
          { label: 'location', key: 'location', type: 'string' },
          { label: 'url', key: 'url', type: 'string' }
        ]
      },
      sendInvoice: {
        label: 'Send Invoice',
        params: [
          {
            label: 'Invoice ID',
            key: 'invoiceId',
            type: 'string'
          },
          {
            label: 'To',
            key: 'toEmail',
            type: 'string'
          },
          {
            label: 'From',
            key: 'fromEmail',
            type: 'string',
            placeholder: 'Optional'
          },
          {
            label: 'Reply To',
            key: 'replyToEmail',
            type: 'string',
            placeholder: 'Optional'
          },
          {
            label: 'Subject',
            key: 'subject',
            type: 'string',
            placeholder: 'Invoice'
          },
          {
            label: 'Template (Default:#Invoice)',
            key: 'templateId',
            type: 'lookup:email-templates',
            placeholder: '#Invoice'
          }
        ]
      }
    }
  },
  Orders: {
    functions: {
      getOrder: {
        version: 2,
        label: 'Get Order',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      orderGetRequiredConsults: {
        version: 2,
        label: 'Get Required Consults',
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Customer ID', key: 'customerId', type: 'string' }
        ]
      },
      orderHasRequirements: {
        version: 2,
        label: 'Check Has Requirements',
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Customer ID', key: 'customerId', type: 'string' }
        ],
        paramsOptional: [
          { label: 'Order Status', key: 'orderStatus', type: 'string' }
        ]
      },
      orderUpdateStatus: {
        version: 2,
        label: 'Update Status',
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Status', key: 'status', type: 'string' }
        ]
      },
      orderReadyToFulfill: {
        version: 2,
        label: 'Find RX + Update Order to Awaiting Fulfillment',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      ordersUpdateSatisfiedRequirements: {
        version: 2,
        label: 'Bulk Update Satisfied Orders',
        params: [{ label: 'Customer ID', key: 'customerId', type: 'string' }]
      },
      orderBulkReject: {
        version: 2,
        label: 'Bulk Reject Order',
        pipelines: ['questionnaire']
      },
      pocketpillsAutoProcess: {
        version: 2,
        label: 'Pocketpills Auto Process',
        params: [],
        pipelines: ['order']
      },
      orderAutoProcess: {
        version: 2,
        label: 'Auto Process Order',
        params: [],
        pipelines: ['order']
      },
      orderAutoProcessV2: {
        version: 2,
        label: 'Auto Process Order V2',
        params: [],
        pipelines: ['order']
      },
      orderAutoAssignPharmacy: {
        version: 2,
        label: 'Auto Assign Pharmacy',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      orderAssignToGroup: {
        version: 2,
        label: 'Assign Group',
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Group Name', key: 'group', type: 'string' }
        ]
      },
      getRecentPrescriptionForOrder: {
        version: 2,
        label: 'Get Prescription for Order',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      orderFulfillWithLastRx: {
        version: 2,
        label: 'Fulfill with last prescription',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      orderFulfillWithLastRxAndAwaitShipment: {
        version: 2,
        label: 'Fulfill last prescription and await shipment',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      customerGetProductEligibleRx: {
        version: 2,
        label: 'Get Eligible RX',
        params: [{ label: 'Order ID', key: 'productId', type: 'string' }]
      },
      orderCharge: {
        version: 2,
        label: 'Charge Order',
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Customer ID', key: 'customerId', type: 'string' },
          {
            label: 'Continue Workflow',
            key: 'continueWorkflow',
            type: 'boolean',
            placeholder: 'Default false'
          }
        ]
      },
      orderRefund: {
        version: 2,
        label: 'Refund Order',
        params: [
          { label: 'Order ID', key: 'orderId', type: 'string' },
          {
            label: 'Refund Amount',
            key: 'amount',
            type: 'number',
            placeholder: 'Optional; full refund if omitted'
          }
        ]
      },
      orderCreateInvoiceInsteadOfPaymentIntent: {
        version: 2,
        label: 'Create Invoice Instead of Payment Intent',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      orderUpdateTracking: {
        version: 2,
        label: 'Update Order Tracking',
        pipelines: ['order', 'webhook'],
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }],
        paramsOptional: [
          { label: 'Tracking Code', key: 'trackingCode', type: 'string' },
          { label: 'Carrier', key: 'carrier', type: 'string' },
          { label: 'Tracking Link', key: 'trackingLink', type: 'string' }
        ]
      },
      updateOrderExtras: {
        label: 'Update Order Extras',
        version: 2,
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }],
        extras: true
      }
    }
  },
  Questionnaires: {
    functions: {
      consultUpdateStatus: {
        version: 2,
        label: 'Update Status',
        params: [
          { label: 'Questionnaire ID', key: 'consultId', type: 'string' },
          { label: 'Status', key: 'status', type: 'string' }
        ]
      },
      getFile: {
        label: 'Get Image File from Consult Question',
        version: 2,
        params: [{ label: 'Question Answer', key: 'link', type: 'string' }]
      }
    }
  },
  WeightLogs: {
    functions: {
      submitWeightLog: {
        version: 2,
        label: 'Submit Weight Log',
        params: [
          { label: 'Customer ID *', key: 'customerId', type: 'string' },
          { label: 'Weight *', key: 'weight', type: 'string' },
          { label: 'Source', key: 'source', type: 'string' }
        ]
      }
    }
  },
  Carts: {
    functions: {
      getCart: {
        version: 2,
        label: 'Get Cart',
        params: [{ label: 'Cart ID', key: 'cartId', type: 'string' }]
      }
    }
  },
  labResults: {
    functions: {
      calculatePhenotypicAge: {
        version: 2,
        label: 'Calculate Phenotypic Age',
        params: [
          { label: 'Lab Result ID', key: 'labResultId', type: 'string' },
          { label: 'Customer ID', key: 'customerId', type: 'string' }
        ]
      },
      verifyByAiConfidence: {
        version: 2,
        label: 'Verify lab result (strictest AI line)',
        params: [
          {
            label:
              'Lab result ID (required). Example when the event payload is the lab document: {{_id}}',
            key: 'labResultId',
            type: 'string'
          },
          { label: 'Verifier User ID', key: 'verifierUserId', type: 'string' }
        ],
        paramsOptional: [
          {
            label:
              'Minimum AI score (percent, default 90). Uses strictest-line score when present; otherwise document-level score.',
            key: 'worstFieldMinPercent',
            type: 'string'
          },
          {
            label:
              'Panel completeness — max expected biomarkers that may be missing (0 = full panel; max 500; leave blank to skip)',
            key: 'maxMissingPanelBiomarkers',
            type: 'string'
          }
        ]
      }
    }
  },
  subscriptions: {
    functions: {
      getSubscription: {
        version: 2,
        label: 'Get Subscription',
        params: [
          { label: 'Subscription ID', key: 'subscriptionId', type: 'string' }
        ]
      },
      pushRenewalDate: {
        version: 2,
        label: 'Push Renewal Date',
        params: [
          { label: 'Subscription ID', key: 'subscriptionId', type: 'string' },
          { label: 'Order ID', key: 'orderId', type: 'string' },
          {
            label: 'Days to push',
            key: 'days',
            type: 'string'
          }
        ]
      },
      getSubscriptionByOrderId: {
        version: 2,
        label: 'Get Subscription by Order ID',
        params: [{ label: 'Order ID', key: 'orderId', type: 'string' }]
      },
      updateSubscriptionStatus: {
        version: 2,
        label: 'Update Subscription Status',
        params: [
          { label: 'Subscription ID', key: 'subscriptionId', type: 'string' },
          { label: 'Order ID', key: 'orderId', type: 'string' },
          { label: 'Status', key: 'status', type: 'string' }
        ]
      }
    }
  },
  Prescriptions: {
    functions: {
      sendToKroll: {
        version: 2,
        label: 'Send to Kroll',
        params: [{ label: 'Rx ID', key: 'rxId', type: 'string' }]
      },
      sendPrescription: {
        version: 2,
        label: 'Send prescription event',
        params: [{ label: 'Rx ID', key: 'rxId', type: 'string' }]
      }
    }
  },
  Products: {
    functions: {
      getProduct: {
        version: 2,
        label: 'Get Product',
        params: [{ label: 'Product ID', key: 'productId', type: 'string' }]
      }
    }
  }
};
